import BaseError from './BaseError';

class MissingUtilError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('MissingUtilError', message, fileName, lineNumber);
  }
}

export default MissingUtilError;
